import React from 'react';
import PropTypes from 'prop-types';

const LocationsBanner = ({ text }) => {
  return (
    <section className="blue-bg py-12 md:py-16 lg:py-20">
      <div className="container mx-auto px-4 md:px-8 max-w-6xl">
        <div className="text-center">
          <p className="primary-text text-lg md:text-xl lg:text-2xl xl:text-3xl leading-relaxed font-normal">
            {text}
          </p>
        </div>
      </div>
    </section>
  );
};

LocationsBanner.propTypes = {
  text: PropTypes.string.isRequired,
};

export default LocationsBanner;